/**
 * Calculates the current scroll sizes of the canvas based on values derived directly from the DOM elements.
 */
export const getCurrentCanvasScrollSizes = (
  currentWindow: Window
): {scrollWidth: number; scrollHeight: number} => {
  const compStyles = currentWindow.getComputedStyle(
    currentWindow.document.body
  );
  // We use `scrollWidth` to calculate the CanvasScrollStore position. If
  // there is margin added to the Body element we need to manually add that to
  // the scrollWidth in order to get the correct width. Example of a bug
  // without this #28005
  const bodyMargins =
    parseInt(compStyles.getPropertyValue('margin-right'), 10) +
    parseInt(compStyles.getPropertyValue('margin-left'), 10);
  const scrollWidth = currentWindow.document.body.scrollWidth + bodyMargins;
  const scrollHeight = currentWindow.document.documentElement.scrollHeight;

  return {scrollWidth, scrollHeight};
};
